const HEX_6 = /^[0-9a-f]{6}$/i;

export const isHexColor = (value: string) => HEX_6.test(value);
export const normalizeHex = (value: string) => value.trim().replace(/^#/, '').toUpperCase();

interface ColorFieldProps {
  id: string;
  label: string;
  hint: string;
  value: string;
  onChange: (value: string) => void;
  showError: boolean;
  disabled?: boolean;
}

export const ColorField = ({ id, label, hint, value, onChange, showError, disabled = false }: ColorFieldProps) => {
  const valid = isHexColor(value);
  const error = showError && !valid ? (value ? 'Enter 6 hex digits, like 1A2B3C.' : `Enter a ${label.toLowerCase()}.`) : '';

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium text-gray-700">
        {label}
      </label>
      <p className="text-xs text-gray-500">{hint}</p>
      <div className="flex items-center gap-2">
        <input
          type="color"
          aria-label={`Pick ${label.toLowerCase()}`}
          value={valid ? `#${value}` : '#000000'}
          onChange={(e) => onChange(normalizeHex(e.target.value))}
          disabled={disabled}
          className="h-9 w-10 shrink-0 cursor-pointer rounded border border-gray-300 bg-white p-0.5 disabled:cursor-not-allowed"
        />
        <div
          className={`flex items-center rounded-lg border bg-white focus-within:ring-2 focus-within:ring-gray-900 ${
            error ? 'border-red-300' : 'border-gray-300'
          }`}
        >
          <span className="pl-3 text-sm text-gray-400" aria-hidden="true">
            #
          </span>
          <input
            id={id}
            type="text"
            value={value}
            onChange={(e) => onChange(normalizeHex(e.target.value))}
            maxLength={7}
            spellCheck={false}
            autoComplete="off"
            placeholder="000000"
            disabled={disabled}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? `${id}-error` : undefined}
            className="w-24 rounded-lg py-2 pl-1 pr-3 font-mono text-sm uppercase focus:outline-none"
          />
        </div>
      </div>
      {error && (
        <p id={`${id}-error`} className="text-xs text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};
